import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useHistory, Link, useLocation } from "react-router-dom";
import { Layout, Menu, Breadcrumb, Modal, Input, message } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { LogoutUser } from "../../Redux/actions/authentication";
import { getCart } from "../../Redux/actions/cartActions";
import CartModal from "../cart/cartModal";
import PackageQRScanner from "../packages/PackageQRScanner";

import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  BarChartOutlined,
  DeploymentUnitOutlined,
  AppstoreOutlined,
  ExclamationCircleOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  LogoutOutlined,
  MessageOutlined,
  ShopOutlined,
  BarsOutlined,
  CoffeeOutlined,
  InboxOutlined,
  QrcodeOutlined,
  AccountBookOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  BarcodeOutlined,
  AreaChartOutlined,
  ShoppingOutlined,
  AuditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import "./styles.scss";
import "./styles.css";

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;
const { confirm } = Modal;

const Index = ({ children }) => {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  const [key, setKey] = useState(1);
  const [password, setPassword] = useState("");

  const { user } = useSelector(
    (state) => ({
      user: state.auth.user,
    }),
    shallowEqual
  );
  useEffect(() => {
    authChecking();
    console.log(user);
    if (user) {
      dispatch(getCart());
    }
  }, [user]);

  const changeRoute = (route) => {
    window.location.href = route; //one level up
  };

  const showConfirm = () => {
    confirm({
      title: "Input Password",
      icon: <ExclamationCircleOutlined />,
      content: (
        <Input.Password
          placeholder="input password"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
        />
      ),
      onOk() {
        if (password === "passbutan") {
          message.success("access granted");
          setKey("3");
          changeRoute("/analytics");
        } else {
          message.error("wrong password");
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const authChecking = () => {
    console.log(user);
    if (user) {
      if (user.role) {
        if (user.role !== "none") {
          setAuthenticated(true);
        } else {
          window.location.href = "/";
        }
      } else {
        window.location.href = "/";
      }
    } else if (
      window.location.pathname !== "/" &&
      window.location.pathname !== "/register"
    ) {
      window.location.href = "/";
    }
  };

  const logoutHandler = () => {
    dispatch(LogoutUser());
    window.location.href = "/";
  };

  return (
    <Layout className="mainDivLayout">
      {collapsed ? null : authenticated ? (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          reverseArrow={true}
        >
          <div className="sider">
            <div>
              <div className="logo" />
              <Menu theme="dark" mode="inline" defaultSelectedKeys={[key]}>
                <Menu.Item key="cart" icon={<ShoppingCartOutlined />}>
                  <CartModal navbutton={true} />
                </Menu.Item>
                <Menu.Item key="scanqr" icon={<QrcodeOutlined />}>
                  <PackageQRScanner
                    showButton={false}
                    onCloseModal={() => {
                      window.reload();
                    }}
                  />
                </Menu.Item>
                <Menu.Item
                  key="packages"
                  icon={<InboxOutlined />}
                  onClick={() => {
                    setKey("packages");
                    changeRoute("/");
                  }}
                >
                  Packages
                </Menu.Item>
                <Menu.Item
                  key="products"
                  icon={<CoffeeOutlined />}
                  onClick={() => {
                    setKey("products");
                    changeRoute("/products");
                  }}
                >
                  Products
                </Menu.Item>
                {user &&
                (user.role == "admin" ||
                  user.role == "oic" ||
                  user.role == "manager") ? (
                  <Menu.Item
                    key="dailysales"
                    icon={<ShoppingOutlined />}
                    onClick={() => {
                      setKey("dailysales");
                      changeRoute("/dailysales");
                    }}
                  >
                    Daily Sales
                  </Menu.Item>
                ) : null}
                <Menu.Item
                  key="monthlyaudit"
                  icon={<AuditOutlined />}
                  onClick={() => {
                    setKey("monthlyaudit");
                    changeRoute("/monthlyaudit");
                  }}
                >
                  Audit
                </Menu.Item>
                {user &&
                (user.role == "warehouse" || user.role == "manager") ? (
                  <Menu.Item
                    key="wasteditems"
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      setKey("wasteditems");
                      changeRoute("/wasteditems");
                    }}
                  >
                    Wasted Items
                  </Menu.Item>
                ) : null}

                {user &&
                (user.role == "admin" ||
                  user.role == "warehouse" ||
                  user.role == "manager") ? (
                  <Menu.Item
                    key="purchasing"
                    icon={<WalletOutlined />}
                    onClick={() => {
                      setKey("purchasing");
                      changeRoute("/purchasing");
                    }}
                  >
                    Purchasing
                  </Menu.Item>
                ) : null}
                {/* {user && (user.role == 'admin' || user.role == 'oic') ?
                  <Menu.Item key="sales" icon={<BarcodeOutlined />} onClick={() => {setKey("sales");  changeRoute('/sales')}}>
                    Sales
                  </Menu.Item>
                :null} */}
                {user && user.role == "admin" ? (
                  <Menu.Item
                    key="productcategories"
                    icon={<BarsOutlined />}
                    onClick={() => {
                      setKey("productcategories");
                      changeRoute("/productcategories");
                    }}
                  >
                    Product Categories
                  </Menu.Item>
                ) : null}
                {user && user.role == "admin" ? (
                  <Menu.Item
                    key="brands"
                    icon={<BarsOutlined />}
                    onClick={() => {
                      setKey("brands");
                      changeRoute("/brands");
                    }}
                  >
                    Brands
                  </Menu.Item>
                ) : null}
                {user && user.role == "admin" ? (
                  <Menu.Item
                    key="locations"
                    icon={<ShopOutlined />}
                    onClick={() => {
                      setKey("locations");
                      changeRoute("/locations");
                    }}
                  >
                    Locations
                  </Menu.Item>
                ) : null}
                {user && user.role == "admin" ? (
                  <Menu.Item
                    key="users"
                    icon={<UserOutlined />}
                    onClick={() => {
                      setKey("admin");
                      changeRoute("/users");
                    }}
                  >
                    Users
                  </Menu.Item>
                ) : null}
                {user && user.role == "admin" ? (
                  <Menu.Item
                    key="exchangerate"
                    icon={<AccountBookOutlined />}
                    onClick={() => {
                      setKey("exchangerate");
                      changeRoute("/exchangerate");
                    }}
                  >
                    Exchange rate
                  </Menu.Item>
                ) : null}
                {user && user.role == "admin" ? (
                  <Menu.Item
                    key="analytics"
                    icon={<AreaChartOutlined />}
                    onClick={() => {
                      setKey("analytics");
                      changeRoute("/analytics");
                    }}
                  >
                    Analytics
                  </Menu.Item>
                ) : null}
              </Menu>
            </div>
            <div>
              <Menu theme="dark" mode="inline" defaultSelectedKeys={[key]}>
                <Menu.Item
                  key="logout"
                  onClick={() => {
                    logoutHandler();
                  }}
                  icon={<LogoutOutlined />}
                >
                  Logout
                </Menu.Item>
              </Menu>
              <div className={"branch"}>{user ? user.branch_name : ""}</div>
              <div className={"branch"}>25.7.2</div>
            </div>
          </div>
        </Sider>
      ) : null}
      <Layout className="site-layout">
        {authenticated ? (
          <div
            onClick={() => {
              setCollapsed(!collapsed);
            }}
            className="iconcollapse"
          >
            {collapsed ? (
              <MenuUnfoldOutlined className={"iconColor"} />
            ) : (
              <MenuFoldOutlined className={"iconColor"} />
            )}
          </div>
        ) : null}

        {/* {user.role == 'oic' ||  user.role == 'admin' ?
            <div>
              
            </div>
       
          :null} */}
        <CartModal />

        <Content
          className="site-layout-background content"
          style={
            user
              ? {
                  margin: "24px 16px",

                  minHeight: 280,
                }
              : null
          }
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Index;
